import request from '@/common/http/request'

// 系统基本信息
export function getSysBaseConfig(data) {
    const timestamp = new Date().getTime()
    return request({
        url: '/home/sysBaseConfig?timestamp=' + timestamp,
        method: 'post',
        data
    })
}
// Facebook推广信息
export function getFacebookConfig(data) {
    return request({
        url: '/setFacebookConfig/get',
        method: 'post',
        data
    })
}
// 获取国家基本信息
export function getNationInfo(data) {
    const timestamp = new Date().getTime()
    return request({
        url: '/enum/Nation?timestamp=' + timestamp,
        method: 'post',
        data
    })
}
// telegram 登录
export function telegramLogin(data) {
    return request({
        url: '/telegram/auth',
        headers: { 'Content-Type': 'application/json' },
        method: 'post',
        data
    })
}
